import React from "react";
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { noData, StyledTableCell } from "../constants";

const ReleaseManagementComponent = (props) => {
  const { rowList, updateClick, tableCols, paginationUI } = props;
  return (
    <React.Fragment>
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          overflowX: "hidden",
          borderRadius: 0,
          // flexGrow: 1,
          background: "transparent",
          // marginBottom: 4.5,
        }}
      >
        <Table
          sx={{ borderCollapse: "collapse", border: 0 }}
          stickyHeader={true}
        >
          <TableHead>
            <TableRow>
              {tableCols.map((el, index) => {
                let sx = {};
                if (el.type === "live") {
                  sx.width = "150px !important";
                  sx.textAlign = "center";
                } else if (el.type === "version") {
                  sx.width = "120px !important";
                }

                return (
                  <StyledTableCell key={index} sx={sx}>
                    {el.title}
                  </StyledTableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {rowList.map((row, rowIndex) => {
              return (
                <React.Fragment key={row?.id}>
                  <TableRow>
                    {tableCols.map((el, index) => {
                      let sx = {};
                      if (el.type === "live") {
                        sx.width = "150px !important";
                        sx.textAlign = "center";
                      } else if (el.type === "version") {
                        sx.width = "120px !important";
                      }
                      return (
                        <StyledTableCell key={index} sx={sx}>
                          {el.type === "link" ? row[el.id] || noData : null}
                          {el.type === "version" ? row[el.id] || noData : null}
                          {el.type === "textarea" ? row[el.id] || noData : null}
                          {el.type === "live" ? (
                            row[el.id] === true ? (
                              <Typography
                                variant="h5"
                                sx={{ textAlign: "center", color: "#008000" }}
                              >
                                Live
                              </Typography>
                            ) : (
                              <Button
                                variant="contained"
                                size="small"
                                onClick={(e) => updateClick(e, row.id)}
                              >
                                Publish
                              </Button>
                            )
                          ) : null}
                        </StyledTableCell>
                      );
                    })}
                  </TableRow>
                </React.Fragment>
              );
            })}
            {!rowList.length ? (
              <TableRow>
                <StyledTableCell colSpan={100} sx={{ textAlign: "center" }}>
                  {noData}
                </StyledTableCell>
              </TableRow>
            ) : (
              paginationUI
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </React.Fragment>
  );
};

export default ReleaseManagementComponent;
